import { DataSource } from '@client/core/data/concerns/data-source';
import { fromJson, JsonResponse } from '@client/core/data/concerns/parses-from-json';
import { Pagination } from '@client/core/http/pagination';
import { HttpResponse, HttpResponseWithMeta, PaginationResponse } from '@client/core/http/types';
import { ActivityLogComment } from '@client/features/activity-log/models/activity-log-comment';
import { CreateActivityLogCommentParams } from '@client/features/activity-log/use-cases/create-activity-log-comment';
import { DestroyActivityLogEntryCommentParams } from '@client/features/activity-log/use-cases/destroy-activity-log-comment';
import { GetActivityLogCommentsParams } from '@client/features/activity-log/use-cases/get-activity-log-comments';
import { UpdateActivityLogCommentParams } from '@client/features/activity-log/use-cases/update-activity-log-comment';

/**
 * @deprecated Activity Log Comments feature is being removed from the software.
 */
export class ActivityLogCommentDataSource extends DataSource {
  /**
   * @see app/Http/Controllers/ActivityLog/CreateActivityLogCommentController.php
   * @deprecated Activity Log Comments feature is being removed from the software.
   */
  async createActivityLogComment(params: CreateActivityLogCommentParams): Promise<ActivityLogComment> {
    const response = await this.httpClient.post<HttpResponse<JsonResponse>>(
      `/workspace/${params.ownerId}/activity-log/${params.activityLogId}/comments`,
      {
        comment_text: params.commentText,
      },
    );

    return fromJson(ActivityLogComment, response.data.data);
  }

  /**
   * @see app/Http/Controllers/ActivityLog/GetActivityLogCommentsController.php
   * @deprecated Activity Log Comments feature is being removed from the software.
   */
  async getActivityLogComments(
    params: GetActivityLogCommentsParams,
  ): Promise<PaginationResponse<ActivityLogComment[]>> {
    const response = await this.httpClient.get<HttpResponseWithMeta<JsonResponse[], Pagination>>(
      `/workspace/${params.ownerId}/activity-log/${params.activityLogId}/comments`,
      {
        params: {
          ...params,
          page: params?.page ?? 1,
        },
      },
    );

    return {
      data: response.data.data.map((json) => fromJson(ActivityLogComment, json)),
      pagination: fromJson(Pagination, response.data.meta),
    };
  }

  /**
   * @see app/Http/Controllers/ActivityLog/DestroyActivityLogCommentController.php
   * @deprecated Activity Log Comments feature is being removed from the software.
   */
  async destroyActivityLogComment(params: DestroyActivityLogEntryCommentParams): Promise<void> {
    await this.httpClient.delete<HttpResponse<void>>(
      `/workspace/${params.ownerId}/activity-log-comments/${params.activityLogCommentId}`,
    );
  }

  /**
   * @see app/Http/Controllers/ActivityLog/UpdateActivityLogCommentController.php
   * @deprecated Activity Log Comments feature is being removed from the software.
   */
  async updateActivityLogComment(params: UpdateActivityLogCommentParams): Promise<ActivityLogComment> {
    const response = await this.httpClient.patch<HttpResponse<JsonResponse>>(
      `/workspace/${params.ownerId}/activity-log-comments/${params.activityLogCommentId}`,
      {
        comment_text: params.commentText,
      },
    );

    return fromJson(ActivityLogComment, response.data.data);
  }
}
